import request from '@/utils/request'
//获取游戏列表
export function getGameList(query){
	return request({
	  url: '/recommendBox/getInfo',
	  method: 'get',
	  params:query
	})
}
export function getGameBanner(query){
	return request({
	  url: '/banner/getInfo',
	  method: 'get',
	  params:query
	})
}
export function getSearch(query){
	return request({
	  url: '/banner/search',
	  method: 'get',
	  params:query
	})
}
export function getActivity(gameId){
	return request({
	  url: 'banner/activity/'+gameId,
	  method: 'get'
	})
}
export function getGmOrder(orderId){
	return request({
	  url: '/function/order/gmVerify/'+orderId,
	  headers: {
	    isToken: false,
	    isMallApi: true
	  },
	  method: 'get'
	})
}
export function getOrder(orderId){
	return request({
	  url: 'payerMax/verify/'+orderId,
	  method: 'get'
	})
}
export function getIntroduction(gameId){
	return request({
	  url: 'banner/strategy/'+gameId,
	  method: 'get'
	})
}
export function getIntroductionDetail(id){
	return request({
	  url: 'banner/details/'+id,
	  method: 'get'
	})
}
export function getNewsList(query){
	return request({
	  url: 'banner/message',
	  method: 'get',
	  params:query
	})
}
export function getNewsDetail(id){
	return request({
	  url: 'banner/messageDetails/'+id,
	  method: 'get'
	})
}
export function getDownloadUrl(gameId,platid){
	return request({
	  url: 'game/'+gameId+'/'+platid,
	  method: 'get'
	})
}
// 开服信息
export function getGameService(query){
	return request({
	  url: '/banner/getGameOpenServiceList/'+query,
	  method: 'get'
	})
}
// 公告
export function getNoticeList(query){
	return request({
	  url: '/banner/notice',
	  method: 'post',
	  data:query
	})
}
// 开服信息
export function getServerList(data){
	return request({
	  url: '/gameService/findGameOpenServerList',
	  method: 'get',
	  params: data
	})
}
// 充值排行
export function getRechargeRanks(data){
	return request({
	  url: '/function/totalMonth/list',
	  headers: {
	    isToken: true,
	    isMallApi: true
	  },
	  method: 'get',
	  params: data
	})
}
export function getMyRecharge(data){
	return request({
	  url: '/function/totalMonth/myTotal',
	  headers: {
	    isToken: true,
	    isMallApi: true
	  },
	  method: 'get',
	  params: data
	})
}
export function getRechargeAward(data){
	return request({
	  url: '/function/totalMonth/getAward',
	  headers: {
	    isToken: true,
	    isMallApi: true
	  },
	  method: 'get',
	  params: data
	})
}
